import React from 'react';
import { Coffee } from '@phosphor-icons/react';

// Small tip-jar block shown under the calculator results.
// URL is fixed — provided by the site owner.
const BMC_URL = 'https://buymeacoffee.com/stefamirtharajah';

export default function BuyMeCoffee() {
  return (
    <div className="mt-12 grid-border" data-testid="bmc-block">
      <div className="grid grid-cols-1 md:grid-cols-5">
        <div className="md:col-span-3 p-6 md:p-10">
          <div className="text-xs uppercase tracking-widest text-neutral-500">Wenn PendelPilot dir geholfen hat</div>
          <h3 className="font-display text-3xl md:text-4xl tracking-tighter mt-2">
            Spendier mir einen Kaffee.
          </h3>
          <p className="text-neutral-700 mt-3 max-w-md">
            PendelPilot ist kostenlos, ohne Werbung und ohne Anmeldung. Wenn dir das Tool geholfen hat, hilf mit einem Kaffee, die Serverkosten zu decken.
          </p>
        </div>
        <div className="md:col-span-2 flex items-center justify-center p-6 md:p-10 border-t md:border-t-0 md:border-l border-neutral-200 bg-[#FFDD00]">
          <a
            href={BMC_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="bmc-button"
            className="inline-flex items-center gap-2 h-14 px-6 bg-neutral-900 text-white text-sm uppercase tracking-widest hover:bg-black"
          >
            <Coffee size={18} weight="bold" />
            Kaffee spendieren
          </a>
        </div>
      </div>
    </div>
  );
}
